/**
 * Функция для добавления окончания тексту
 * @param description
 */
export function getDescriptionWithEnding(description: string) {
    const exceptions = ['.', '!', '?'];
    const lastCharExceptions = ['—', '-'];

    if (!description) {
        return '';
    }

    const lastDescriptionChar = description[description.length - 1];

    if (exceptions.includes(lastDescriptionChar)) {
        return description;
    }

    if (lastCharExceptions.includes(lastDescriptionChar)) {
        return `${description.slice(0, description.length - 2)}...`;
    }

    return `${description}...`;
}